import { QuestionnaireModalType } from "@/models/Form/QuestionnaireModalType";

export enum QuestionnaireDisplayMode {
    BOOKING = "reservation",
    PERSON = "person",
    PURCHASE = "purchase",
    PER_PASS_IN_PURCHASE = "pass in purchase",
}

export const isBeforePaymentType = (modalType: QuestionnaireModalType) => {
    return [QuestionnaireModalType.BIRTH_DATE, QuestionnaireModalType.MARKETING_CONSENT].includes(modalType);
};

export const isMarketingConsentType = (modalType: QuestionnaireModalType) => {
    return modalType === QuestionnaireModalType.OPT_IN || modalType === QuestionnaireModalType.MARKETING_CONSENT;
};
